<template>
  <div
    class="tw-w-full tw-mt-4 tw-p-6 tw-bg-red-250 tw-rounded-lg tw-border-red-300 tw-border tw-flex tw-items-center"
  >
    <div class="tw-flex tw-flex-1 tw-min-w-0">
      <div class="tw-py-1 tw-mr-3 tw-flex-shrink-0">
        <SvgIcon
          class="tw-w-6 tw-h-6"
          name="exclamation-error-triangle-solid"
        />
      </div>
      <div class="tw-flex-1 tw-min-w-0">
        <p class="tw-text-gray-900 tw-text-lg tw-font-medium tw-mb-2 tw-mt-1">
          You have <strong>{{ employmentsCount }}</strong> employees, but your
          subscription only includes <strong>{{ seats }}</strong> licenses.
          Please upgrade your subscription to regain access to booking and
          cancelling leave.
        </p>
        <div class="tw-flex tw-items-center tw-mt-3">
          <div
            class="tw-h-2 tw-rounded-full tw-overflow-hidden tw-bg-red-300 tw-mr-3 tw-flex seats-exceeded-bar"
          >
            <div
              class="tw-h-full seats-exceeded-solid"
              :style="{ width: coveredPercentage + '%' }"
            ></div>
            <div
              class="tw-h-full seats-exceeded-stripes"
              :style="{ width: 100 - coveredPercentage + '%' }"
            ></div>
          </div>
          <span class="tw-text-gray-700 tw-text-sm">
            {{ usedPercentage }}%
            <span class="tw-ml-2">
              ({{ employmentsCount }} of {{ seats }} employees)
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="tw-ml-4 tw-flex-shrink-0">
      <button
        class="tw-bg-white tw-rounded-full tw-px-5 tw-py-2 tw-font-semibold tw-text-gray-900 tw-border-2 tw-border-gray-900 hover:tw-bg-gray-100"
        type="button"
        @click="goToBilling"
      >
        &rarr; Go to Billing
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeatsExceeded',

  computed: {
    employmentsCount() {
      return this.activeCompany.employments_count
    },

    seats() {
      return this.activeCompany.seatLimit
    },

    usedPercentage() {
      if (!this.seats) return 0
      return Math.floor((this.employmentsCount / this.seats) * 100)
    },

    coveredPercentage() {
      if (!this.employmentsCount) return 0
      if (this.seats >= this.employmentsCount) return 100
      return (this.seats / this.employmentsCount) * 100
    },
  },

  methods: {
    goToBilling() {
      window.location.href = `/settings/billing?company=${this.activeCompany.id}`
    },
  },
}
</script>

<style scoped>
.seats-exceeded-bar {
  width: 240px;
  max-width: 100%;
}

.seats-exceeded-solid {
  background-color: #c53030;
}

.seats-exceeded-stripes {
  background: repeating-linear-gradient(
    -45deg,
    #c53030,
    #c53030 3px,
    #4a1010 3px,
    #4a1010 4px
  );
}
</style>
